const dynamicScripts = {
  cloudpayments: {
    src: 'https://widget.cloudpayments.ru/bundles/cloudpayments.js',
    loaded: false,
  },
  tiptoppay: {
    src: 'https://widget.tiptoppay.kz/bundles/widget.js',
    loaded: false,
  },
};

const ScriptLoaderModule = {
  namespaced: true,
  state: {
    dynamicScripts,
  },
  getters: {},
  actions: {
    loadScript: (ctx, scriptName) => {
      const script = ctx.state.dynamicScripts[scriptName];
      if (!script) {
        throw new Error('wrong script name');
      }

      return new Promise((resolve, reject) => {
        // Если скрипт уже загружен, сразу делаем resolve.
        if (script.loaded) {
          resolve({ loaded: true });
          return;
        }

        // Создаем элемент скрипта.
        const scriptElement = document.createElement('script');
        scriptElement.type = 'text/javascript';
        scriptElement.src = script.src;

        // Загружаем скрипт.
        scriptElement.onload = () => {
          ctx.commit('setScriptLoaded', scriptName);
          resolve({ loaded: true });
        };

        // Обработка на случай ошибки.
        scriptElement.onerror = () => {
          reject(new Error('script load error'));
        };

        // Добавляем элемент скрипта в dom.
        document.getElementsByTagName('head')[0].appendChild(scriptElement);
      });
    },
  },
  mutations: {
    setScriptLoaded: (state, key) => {
      state.dynamicScripts[key].loaded = true;
    },
  },
};

export default ScriptLoaderModule;
